module.exports = __webpack_public_path__ + "static/img/cont43_02.17a6fbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_02.jpg
// module id = /pUa
// module chunks = 0